import React from "react";

const HindiHorrorStory = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <h2>Privacy Policy</h2>
      <p>
        <em>Last updated: 21/4/2024</em>
      </p>

      <p>
        Thank you for choosing to immerse yourself in the world of Hindi Horror Story! We value your privacy and strive to be transparent about how our app operates. This privacy policy outlines the type of data our app collects and how we handle it.
      </p>

      <h3>Data Collection</h3>
      <ul>
        <li>
          <strong>No Personal Data Collection:</strong> Our app does not collect any personal data or identifiable information from users.
        </li>
        <li>
          <strong>No Third-Party Data Sharing:</strong> We do not share any data with third parties as we do not collect any data from users.
        </li>
      </ul>

      <h3>Permissions</h3>
      <ul>
        <li>
          <strong>No Device Permissions:</strong> Our app does not require any specific permissions from the device to function.
        </li>
        <li>
          <strong>Offline Usage:</strong> The app is designed to work completely offline and does not require an internet connection to enjoy the stories.
        </li>
      </ul>

      <h3>Security</h3>
      <ul>
        <li>
          <strong>User Data Protection:</strong> Since we do not collect any user data, there is no risk of data breaches or leaks.
        </li>
        <li>
          <strong>Safe Experience:</strong> We strive to provide a safe and secure app experience for all users.
        </li>
      </ul>

      <h3>Changes to Privacy Policy</h3>
      <p>
        We may update this privacy policy from time to time to reflect changes in our app or legal requirements. We encourage you to review this policy periodically to stay informed about how we are protecting your privacy.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions or concerns about this privacy policy, please contact us at:
      </p>
      <p>
        Email:{" "}
        <a
          href="mailto:sanjumahto328@gmail.com"
          style={{ textDecoration: "none", color: "black" }}
        >
          <b>sanjumahto328@gmail.com</b>
        </a>
      </p>

      <p>Sincerely,</p>
      <p>Sanju Mahto</p>
      <p>Solo Developer</p>
    </div>
  );
};

export default HindiHorrorStory;
